<div class="db-button-group-container" *ngIf="pagesCount >= 1">
  <div class="db-button-group">
    <p class="displayed_count" *ngIf="itemsCount != 0" [innerHTML]="'text_paginationDisplay' | dbText: {firstItemPerPage: (currentPage - 1) * itemsPerPage + 1, lastItemPerPage: ( ((currentPage - 1) * itemsPerPage + itemsPerPage) < itemsCount ? (currentPage - 1) * itemsPerPage + itemsPerPage : itemsCount ), allItems: itemsCount}"></p>
    <p class="displayed_count" *ngIf="itemsCount === 0" [innerHTML]="'text_noResultSearch' | dbText"></p>
    <div class="db-pagination_numbers">
      <span *ngIf="pagesCount > 1">
        <a class="db-button pagination-control pagination-control__multiple" (click)="changePage($event, 1)">
          <i class="db-icon db-icon-arrow-down db-pagination-left"></i>
          <i class="db-icon db-icon-arrow-down db-pagination-left"></i>
        </a>
      </span>

      <span *ngIf="itemsCount != 0">
        <a class="db-button pagination-control" (click)="changePage($event, currentPage - 1)"  [ngClass]="{'db-button_disabled': currentPage === 1}">
          <i class="db-icon db-icon-arrow-down db-pagination-left"></i>
        </a>
      </span>

      <span *ngIf="currentPage" class="current-page">
        <a class="db-button pagination-control pagination-control-active">{{currentPage}}</a>
        <span *ngIf="pagesCount">of {{pagesCount}}</span>
      </span>

      <span *ngIf="itemsCount != 0 && pagesCount > 1">
        <a class="db-button pagination-control" (click)="changePage($event, currentPage + 1)" [ngClass]="{'db-button_disabled': currentPage === pagesCount}">
          <i class="db-icon db-icon-arrow-down db-pagination-right"></i>
        </a>
      </span>

      <span *ngIf="pagesCount > 1"  class="db-button pagination-control pagination-control__multiple">
        <a class="db-button pagination-control" (click)="changePage($event, pagesCount)">
          <i class="db-icon db-icon-arrow-down db-pagination-right"></i>
          <i class="db-icon db-icon-arrow-down db-pagination-right"></i>
        </a>
      </span>
    </div>
  </div>
</div>
